import { render } from "./PieChart.vue?vue&type=template&id=581e5735"
import script from "./PieChart.vue?vue&type=script&lang=ts"
export * from "./PieChart.vue?vue&type=script&lang=ts"
script.render = render

export default script